<template>
  <div id="app">
    <template v-if="loading">
      <div class="loading-screen">
        <h1>{{ lang === 'en' ? 'Loading...' : 'Načítavanie...' }}</h1>
      </div>
    </template>
    <template v-else>
      <building-viewer id="building-viewer"></building-viewer>
      <floor-viewer id="floor-viewer" :key="floor"></floor-viewer>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'utils/misc';
import { loadImages, Stopwatch } from 'utils/timing';

import { IMG_URL } from 'src/constants';

import Presentation from 'components/presentation/Presentation.vue';
import Slide from 'components/presentation/Slide.vue';
import FloorViewer from 'components/floor-viewer/FloorViewer.vue';
import BuildingViewer from 'components/BuildingViewer.vue';

export default {
  name: 'App',
  components: {
    Presentation,
    Slide,
    FloorViewer,
    BuildingViewer,
  },
  computed: {
    ...mapGetters({
      slide: ['getSlide', 'setSlide'],
      floor: ['getFloor', 'setFloor'],
      loading: ['getLoading', 'setLoading'],
      lang: ['getLang', 'setLang'],
    }),
  },
  watch: {
    'keyboardTracker.lastChange'() {
      this.keyboardTracker.isPressed('Escape') ? (this.slide = 1) : null;
    },
  },
  created() {
    const stopwatch = new Stopwatch().start();
    loadImages([
      IMG_URL + 'floors/veza-2NP.png',
      IMG_URL + 'floors/veza-3NP.png',
      IMG_URL + 'floors/veza-4NP.png',
      IMG_URL + 'floors/veza-5NP.png',
      IMG_URL + 'floors/veza-6NP.png',
      IMG_URL + 'floors/3NP.png',
      IMG_URL + 'floors/4NP.png',
      IMG_URL + 'floors/5NP.png',
      IMG_URL + 'floors/6NP.png',
      IMG_URL + 'homepage.jpg',
    ]).then(() => {
      this.loading = false;
      console.log('App loaded in ' + stopwatch.stop().time + 'ms');
    });
  },
};
</script>
